interface SectionSubPageProps {
  eyebrow: string;
  title: string;
  description: string;
}

export function SectionSubPage({
  eyebrow,
  title,
  description,
}: SectionSubPageProps) {
  return (
    <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col gap-6 overflow-y-auto px-6 py-10">
      <header className="space-y-1">
        <p className="text-sm font-medium uppercase tracking-widest text-neutral-500">
          {eyebrow}
        </p>
        <h1 className="text-3xl font-semibold tracking-tight text-whart-text">
          {title}
        </h1>
      </header>

      <section className="wireframe-border bg-whart-bg p-6">
        <p className="text-neutral-600">{description}</p>
      </section>
    </div>
  );
}
